/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/fighter_lvl': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M13.354 6.646a.5.5 0 00-.707 0L10 9.293 7.354 6.646a.5.5 0 00-.707.707L9.293 10l-2.646 2.646a.5.5 0 00.707.708L10 10.707l2.646 2.646a.5.5 0 10.708-.706L10.707 10l2.646-2.646a.5.5 0 00.001-.708zM9 2.069V.051C4.283.521.521 4.283.051 9H2.07A8.008 8.008 0 019 2.069zM17.932 9h2.02C19.479 4.283 15.717.521 11 .051V2.07A8.01 8.01 0 0117.932 9zM11 17.932v2.02c4.717-.473 8.479-4.232 8.949-8.949h-2.02A8.008 8.008 0 0111 17.932zM2.069 11H.051c.47 4.717 4.232 8.479 8.949 8.949v-2.02A8.006 8.006 0 012.069 11z"/>'
  }
})
